import standardDetailLayoutRoute from '@input-web/modules/standard/views/detail-layout/standard-detail-layout.route';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

const standardQuestionDetailRoute = createRoute({
  component: lazyRouteComponent(() => import('./standard-question-detail.view')),
  getParentRoute: () => standardDetailLayoutRoute,
  path: '/question',
});

export default standardQuestionDetailRoute;
